document.addEventListener('DOMContentLoaded', () => {
    function gatedContentSubmitHook(gatedContentURL) {
        const redirectNotice = document.getElementById("gatedContentRedirectNotice");
        redirectNotice.classList.remove('d-none');
        redirectNotice.classList.add('d-block');
        let req = new XMLHttpRequest();
        let fetchURL = new URL(gatedContentURL);
        req.addEventListener('load', gatedContentAfterSubmit);
        req.open("get", fetchURL.href);
        req.send();
    }

    function gatedContentAfterSubmit(res) {

        setTimeout(function () {
            if (history.scrollRestoration) {
                history.scrollRestoration = 'manual';
            } else {
                window.onbeforeunload = function () {
                    window.scrollTo(0, 0);
                }
            }
            location.reload();
        }, 3000);
    }

    window.gatedContentSubmitHook = gatedContentSubmitHook;
});
